
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c8MbJ", function(module, exports) {

$parcel$export(module.exports, "LabelsSelect", () => $0c83ec331acae917$export$4b60771fa800255a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $jhwJP = parcelRequire("jhwJP");

var $jmjWc = parcelRequire("jmjWc");

var $9wGTI = parcelRequire("9wGTI");

var $b5LuY = parcelRequire("b5LuY");

var $82T6H = parcelRequire("82T6H");

const $0c83ec331acae917$var$LabelsMovedChangeboardingLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "C7L99",
    name: "LabelsMovedChangeboardingLoader",
    loader: async ()=>(await (parcelRequire("5ZTcm"))).LabelsMovedChangeboarding
});
const $0c83ec331acae917$var$i18nBase = (0, $2nPZH.defineMessages)({
    labelAlreadyAddedMessage: {
        id: "labels.labels-select.create-new-label-already-added",
        defaultMessage: "{inputValue} was already added to the page"
    },
    labelSearchErrorMessage: {
        id: "labels.labels-select.labels-search-error",
        defaultMessage: "Suggestions aren\u2019t loading. Try writing it again or refresh."
    }
});
const $0c83ec331acae917$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    labelAlreadyAddedMessage: {
        id: "labels.labels-select.create-new-label-already-added.livedocs",
        defaultMessage: "{inputValue} was already added"
    }
});
const $0c83ec331acae917$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($0c83ec331acae917$var$i18nBase, $0c83ec331acae917$var$i18nLiveDocs);
const $0c83ec331acae917$export$4b60771fa800255a = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ contentId: contentId, source: source, experienceName: experienceName, components: components, styles: styles, spaceKey: spaceKey, isInDialog: //@ts-ignore react-select types
isInDialog, onUpdateSuccess: onUpdateSuccess, onAdded: //@ts-ignore react-select types
onAdded, onShowMeClick: onShowMeClick, ...customProps }, ref)=>{
    const { isDisabled: isDisabled, labelsQueryLoading: labelsQueryLoading, labelsQueryError: labelsQueryError, labelsMutationError: labelsMutationError, labelsSearchQueryError: labelsSearchQueryError, validationError: validationError, fetchRecommendedLabels: fetchRecommendedLabels, ...controlledProps } = (0, $b5LuY.useLabelsSelectProps)({
        contentId: contentId,
        source: source,
        onUpdateSuccess: onUpdateSuccess,
        onAdded: onAdded
    });
    const intl = (0, $dBxQj.default)();
    const getNoOptionsMessage = (inputValue)=>{
        if (!inputValue || (0, $b5LuY.isStarredLabel)(inputValue) || validationError) return null;
        if (labelsSearchQueryError) return intl.formatMessage($0c83ec331acae917$var$i18n.labelSearchErrorMessage);
        return intl.formatMessage($0c83ec331acae917$var$i18n.labelAlreadyAddedMessage, {
            inputValue: inputValue
        });
    };
    if (source === 'viewPage' && (0, $9wGTI.fg)('confluence_frontend_remove_labels')) {
        if (!labelsQueryLoading && !labelsQueryError && controlledProps.value.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c83ec331acae917$var$LabelsMovedChangeboardingLoader, {
            onShowMeClick: onShowMeClick
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $82T6H.LabelsSelectComponent), {
        isDisabled: isDisabled,
        labelsQueryLoading: labelsQueryLoading,
        labelsQueryError: labelsQueryError,
        labelsMutationError: labelsMutationError,
        validationError: validationError,
        fetchRecommendedLabels: fetchRecommendedLabels,
        experienceName: experienceName,
        isInDialog: isInDialog,
        ref: ref,
        spaceKey: spaceKey,
        source: source,
        styles: styles,
        customProps: customProps,
        controlledProps: controlledProps,
        components: components,
        getNoOptionsMessage: getNoOptionsMessage
    });
});

});
parcelRegister("jhwJP", function(module, exports) {

$parcel$export(module.exports, "mergeLiveDocI18n", () => $8e78cdefc122a0a9$export$d1326a8d9df930b6);

var $9wGTI = parcelRequire("9wGTI");
const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};

});

parcelRegister("b5LuY", function(module, exports) {

$parcel$export(module.exports, "getPrivacySafePrefix", () => $254135e4510bd987$export$72ac890f53ba46be);
$parcel$export(module.exports, "isStarredLabel", () => $254135e4510bd987$export$bfc1bf0a5d12c626);
$parcel$export(module.exports, "useLabelsSelectProps", () => $254135e4510bd987$export$da1c2a9c6990a15a);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $kyKWe = parcelRequire("kyKWe");

var $cWkqs = parcelRequire("cWkqs");

var $2jjxD = parcelRequire("2jjxD");

var $hJzqL = parcelRequire("hJzqL");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $bQm3c = parcelRequire("bQm3c");

var $hp2SH = parcelRequire("hp2SH");
var $7Sm4c = parcelRequire("7Sm4c");

var $3jwuS = parcelRequire("3jwuS");

var $gEtAQ = parcelRequire("gEtAQ");

var $9wGTI = parcelRequire("9wGTI");

var $775f2 = parcelRequire("775f2");

var $eDV4X = parcelRequire("eDV4X");

var $7vJu5 = parcelRequire("7vJu5");
const $254135e4510bd987$var$useLabelsSelectPropsSSRLabelsQuery = (0, $d2LG0.default)`query useLabelsSelectPropsSSRLabelsQuery($contentId:ID!){content(id:$contentId){nodes{id type status operations{operation targetType}space{id}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count nodes{id label name prefix}}}}}`;
const $254135e4510bd987$var$useLabelsSelectPropsAddLabelsMutation = (0, $d2LG0.default)`mutation useLabelsSelectPropsAddLabelsMutation($contentId:ID!$labels:[LabelInput!]!){addLabels(input:{contentId:$contentId labels:$labels}){labels{count nodes{id prefix name label}}}}`;
const $254135e4510bd987$var$useLabelsSelectPropsDeleteLabelMutation = (0, $d2LG0.default)`mutation useLabelsSelectPropsDeleteLabelMutation($contentId:ID!$label:String!){deleteLabel(input:{contentId:$contentId label:$label}){contentId label}}`;
const $254135e4510bd987$var$useLabelsSelectPropsLabelSearchQuery = (0, $d2LG0.default)`query useLabelsSelectPropsLabelSearchQuery($contentId:ID!$searchText:String!){contentLabelSearch(contentId:$contentId searchText:$searchText){suggestedLabels{prefix name id label}otherLabels{prefix name id label}}}`;
const $254135e4510bd987$var$useLabelsSelectPropsRecommendedLabelsQuery = (0, $d2LG0.default)`query useLabelsSelectPropsRecommendedLabelsQuery($contentId:ID!$spaceId:ID!){getRecommendedLabels(entityId:$contentId entityType:"page" spaceId:$spaceId){recommendedLabels{id name namespace strategy}}}`;
const $254135e4510bd987$var$i18n = (0, $2nPZH.defineMessages)({
    suggestedLabels: {
        id: "labels.use-labels-select-props.suggested-labels",
        defaultMessage: "Suggested labels"
    }
});
const $254135e4510bd987$var$getValidationError = (inputValue)=>{
    const parsedInputValue = inputValue.replace(/^my:/, '');
    if (parsedInputValue.match((0, $eDV4X.INVALID_CHARACTERS))) // list taken from monolith here: com/atlassian/confluence/labels/LabelParser.java:39
    return 'labelsValidationInvalidCharacter';
    else if (parsedInputValue.match(/^~/)) return 'labelsValidationTilde';
    if (parsedInputValue.length > 255) return 'labelsValidationLength';
    return '';
};
const $254135e4510bd987$var$isLabelNotFoundError = (error)=>/No label found with name/.test((0, $775f2.parseErrorMessage)(error).message);
const $254135e4510bd987$var$isContentNotFoundError = (error)=>/No content found with id/.test((0, $775f2.parseErrorMessage)(error).message);
const $254135e4510bd987$var$isLabelDeletePermissionsError = (error)=>/Could not delete label from content with id/.test((0, $775f2.parseErrorMessage)(error).message);
const $254135e4510bd987$var$isLabelMutationLoggedOutError = (error)=>/Current user not permitted to use Confluence/.test((0, $775f2.parseErrorMessage)(error).message);
const $254135e4510bd987$var$isLabelSearch403Error = (error)=>/Unexpected status code 403/.test((0, $775f2.parseErrorMessage)(error).message);
const $254135e4510bd987$export$72ac890f53ba46be = (prefix = '')=>prefix.match(/my|global|team/)?.[0];
const $254135e4510bd987$export$bfc1bf0a5d12c626 = (label)=>label === 'my:favourite' || label === 'my:favorite';
const $254135e4510bd987$var$filterByPrefix = (labels, prefix)=>(labels || []).filter((label)=>label?.prefix === prefix);
const $254135e4510bd987$var$transformToPrefixedLabel = (prefix, label)=>`${prefix && prefix !== 'global' ? `${prefix}:` : ''}${label}`;
const $254135e4510bd987$var$sanitizeInputValue = (input)=>{
    return input.toLowerCase().replace(/\s/g, '-');
};
const $254135e4510bd987$var$getRecommendedLabelsFromData = (data)=>data?.getRecommendedLabels?.recommendedLabels;
const $254135e4510bd987$var$makeTransformLabelToOption = (strategy)=>(label)=>{
        const prefixedLabel = $254135e4510bd987$var$transformToPrefixedLabel(label.prefix, label.label);
        return {
            id: label.id,
            label: prefixedLabel,
            value: prefixedLabel,
            prefix: label.prefix,
            name: label.name,
            strategy: strategy
        };
    };
const $254135e4510bd987$var$transformRecommendedLabelToOption = (label)=>{
    const prefixedLabel = $254135e4510bd987$var$transformToPrefixedLabel(label.namespace, label.name);
    return {
        id: label.id,
        label: prefixedLabel,
        value: prefixedLabel,
        prefix: label.namespace,
        name: label.name,
        strategy: 'recommended',
        subStrategy: label.strategy
    };
};
const $254135e4510bd987$var$transformCurrentLabelsToSelectedOptions = (currentLabels)=>{
    if (!currentLabels) return [];
    return (currentLabels?.content?.nodes?.[0]?.labels?.nodes || []).map($254135e4510bd987$var$makeTransformLabelToOption('current')).filter(({ label: label })=>!$254135e4510bd987$export$bfc1bf0a5d12c626(label));
};
const $254135e4510bd987$var$useOptions = ({ searchLabelQueryResults: searchLabelQueryResults, recommendedLabelsQueryResults: recommendedLabelsQueryResults, hasInput: hasInput })=>{
    const intl = (0, $dBxQj.default)();
    return (0, $gwFzn.useMemo)(()=>{
        if (hasInput) {
            const otherLabelOptions = (searchLabelQueryResults?.contentLabelSearch?.otherLabels || []).map($254135e4510bd987$var$makeTransformLabelToOption('searched_other'));
            const suggestedLabelOptions = (searchLabelQueryResults?.contentLabelSearch?.suggestedLabels || []).map($254135e4510bd987$var$makeTransformLabelToOption('searched_suggested'));
            return [
                ...suggestedLabelOptions,
                ...otherLabelOptions
            ];
        } else {
            const recommendedLabelOptions = ($254135e4510bd987$var$getRecommendedLabelsFromData(recommendedLabelsQueryResults) || []).map($254135e4510bd987$var$transformRecommendedLabelToOption);
            return [
                {
                    label: intl.formatMessage($254135e4510bd987$var$i18n.suggestedLabels),
                    options: recommendedLabelOptions
                }
            ];
        }
    }, [
        searchLabelQueryResults,
        recommendedLabelsQueryResults,
        hasInput,
        intl
    ]);
};
const $254135e4510bd987$export$da1c2a9c6990a15a = ({ contentId: contentId, source: source, onUpdateSuccess: onUpdateSuccess, onAdded: onAdded })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [validationError, setValidationError] = (0, $gwFzn.useState)('');
    const [inputValue, setInputValue] = (0, $gwFzn.useState)('');
    const isLabelsPreloadedFromContent = Boolean(// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window.__SSR_RENDERED__ && ((0, $gEtAQ.isViewPage)() || (0, $gEtAQ.isBlogPage)()) || undefined);
    const { data: ssrLabelsQueryData, loading: ssrLabelsQueryLoading, error: ssrLabelsQueryError } = (0, $j1Ss3.useQuery)($254135e4510bd987$var$useLabelsSelectPropsSSRLabelsQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isLabelsPreloadedFromContent
    });
    const { data: labelsQueryData, loading: labelsQueryLoading, error: labelsQueryError } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $7vJu5.LabelsQuery), {
        variables: {
            contentId: contentId,
            refetchQuery: false,
            status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
        },
        skip: isLabelsPreloadedFromContent,
        fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_remove_labels') ? undefined : 'cache-and-network'
    });
    const labelData = (0, $gwFzn.useMemo)(()=>{
        if (isLabelsPreloadedFromContent) {
            if (!(0, $eDV4X.ALLOWED_CONTENT_STATUSES).includes(ssrLabelsQueryData?.content?.nodes?.[0]?.status || '')) return null;
            return ssrLabelsQueryData;
        }
        return labelsQueryData;
    }, [
        ssrLabelsQueryData,
        labelsQueryData,
        isLabelsPreloadedFromContent
    ]);
    const selectedOptions = (0, $gwFzn.useMemo)(()=>$254135e4510bd987$var$transformCurrentLabelsToSelectedOptions(labelData), [
        labelData
    ]);
    const type = labelData?.content?.nodes?.[0]?.type;
    const spaceId = labelData?.content?.nodes?.[0]?.space?.id || '';
    // this will be used to disable add/delete if the user doesn't have page edit permissions
    const isDisabled = !labelData?.content?.nodes?.[0]?.operations?.find((item)=>{
        return item?.operation === 'update' && item?.targetType === type;
    });
    (0, $gwFzn.useEffect)(()=>{
        !(labelsQueryLoading || ssrLabelsQueryLoading) && createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'labels',
                containerId: spaceId,
                containerType: 'space',
                objectId: contentId,
                objectType: type,
                source: source,
                attributes: {
                    count: {
                        global: $254135e4510bd987$var$filterByPrefix(selectedOptions, 'global').length,
                        personal: $254135e4510bd987$var$filterByPrefix(selectedOptions, 'my').length,
                        total: selectedOptions.length
                    },
                    ...isLivePage ? {
                        isLivePage: isLivePage
                    } : null
                }
            }
        }).fire();
    }, [
        labelsQueryLoading,
        ssrLabelsQueryLoading,
        selectedOptions,
        spaceId,
        contentId,
        type,
        source,
        createAnalyticsEvent,
        isLivePage
    ]);
    const [addLabel, { error: addError }] = (0, $j1Ss3.useMutation)($254135e4510bd987$var$useLabelsSelectPropsAddLabelsMutation, {
        update (cache, { data: data }) {
            const cachedData = cache.readQuery({
                query: (0, $7vJu5.LabelsQuery),
                variables: {
                    contentId: contentId,
                    refetchQuery: false,
                    status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                }
            });
            if (cachedData?.content?.nodes?.[0] && data?.addLabels?.labels) {
                const newLabels = (0, (/*@__PURE__*/$parcel$interopDefault($cWkqs)))(cachedData.content.nodes[0].labels?.nodes, data.addLabels?.labels.nodes, 'id');
                cachedData.content.nodes[0].labels = {
                    count: newLabels.length,
                    nodes: newLabels,
                    // @ts-ignore
                    __typename: 'PaginatedLabelList'
                };
                cache.writeQuery({
                    query: (0, $7vJu5.LabelsQuery),
                    variables: {
                        contentId: contentId,
                        refetchQuery: false,
                        status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                    },
                    data: cachedData
                });
            }
        },
        onCompleted: ()=>{
            if (onUpdateSuccess) onUpdateSuccess();
            if (onAdded) onAdded();
        }
    });
    const handleDeleteLabelUpdate = (0, $gwFzn.useCallback)((cache, { data: data })=>{
        const cachedData = cache.readQuery({
            query: (0, $7vJu5.LabelsQuery),
            variables: {
                contentId: contentId,
                refetchQuery: false,
                status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
            }
        });
        if (cachedData?.content?.nodes?.[0]?.labels?.nodes && cachedData?.content?.nodes?.[0]?.labels?.count != null) {
            // TODO: label is not a unique identifier. Either prefix + label or label id should be used instead, but neither are returned by the mutation
            const filteredCachedLabels = cachedData.content.nodes[0].labels.nodes.filter((node)=>node?.label !== data?.deleteLabel?.label);
            cache.writeQuery({
                query: (0, $7vJu5.LabelsQuery),
                variables: {
                    contentId: contentId,
                    refetchQuery: false,
                    status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                },
                data: {
                    content: {
                        nodes: [
                            {
                                ...cachedData.content.nodes[0],
                                labels: {
                                    nodes: filteredCachedLabels,
                                    count: filteredCachedLabels.length,
                                    // @ts-ignore
                                    __typename: 'PaginatedLabelList'
                                }
                            }
                        ],
                        __typename: 'PaginatedContentListWithChild'
                    }
                }
            });
        }
    }, [
        contentId
    ]);
    const [deleteLabel, { error: rawDeleteError }] = (0, $j1Ss3.useMutation)($254135e4510bd987$var$useLabelsSelectPropsDeleteLabelMutation, {
        update: handleDeleteLabelUpdate,
        onCompleted: ()=>{
            if (onUpdateSuccess) onUpdateSuccess();
        }
    });
    const deleteError = !$254135e4510bd987$var$isLabelNotFoundError(rawDeleteError) ? rawDeleteError : undefined;
    const [searchQuery, { data: searchLabelQueryResults, loading: searchLabelQueryLoading, error: searchLabelQueryError }] = (0, $j1Ss3.useLazyQuery)($254135e4510bd987$var$useLabelsSelectPropsLabelSearchQuery, {
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE)
            });
        },
        onError: (error)=>{
            if ($254135e4510bd987$var$isLabelSearch403Error(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE),
                    reason: 'User was logged out'
                });
            }
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE)
            });
        }
    });
    const [recommendedLabelsQuery, { data: recommendedLabelsQueryResults, loading: recommendedLabelsQueryLoading }] = (0, $j1Ss3.useLazyQuery)($254135e4510bd987$var$useLabelsSelectPropsRecommendedLabelsQuery, {
        variables: {
            contentId: contentId,
            spaceId: spaceId
        },
        onCompleted: (data)=>{
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_RECOMMENDED_EXPERIENCE)
            });
            const recommendedLabels = $254135e4510bd987$var$getRecommendedLabelsFromData(data);
            recommendedLabels && createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'labelRecommendations',
                    source: source,
                    containerId: spaceId,
                    containerType: 'space',
                    objectId: contentId,
                    objectType: type,
                    attributes: {
                        count: recommendedLabels?.length
                    }
                }
            }).fire();
        },
        onError: (error)=>{
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_RECOMMENDED_EXPERIENCE)
            });
        }
    });
    const fetchRecommendedLabels = (0, $gwFzn.useCallback)(()=>{
        if (type === 'page' && !isDisabled) {
            experienceTracker.start({
                name: (0, $irVI7.LABELS_RECOMMENDED_EXPERIENCE)
            });
            recommendedLabelsQuery();
        }
    }, [
        type,
        experienceTracker,
        recommendedLabelsQuery,
        isDisabled
    ]);
    const recommendedLabels = $254135e4510bd987$var$getRecommendedLabelsFromData(recommendedLabelsQueryResults);
    const options = $254135e4510bd987$var$useOptions({
        searchLabelQueryResults: searchLabelQueryResults,
        recommendedLabelsQueryResults: recommendedLabelsQueryResults,
        hasInput: Boolean(inputValue)
    });
    const debouncedSearchQuery = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(searchQuery, 150, {
            leading: true
        }), [
        searchQuery
    ]);
    const handleInputChange = (inputValue)=>{
        const error = $254135e4510bd987$var$getValidationError(inputValue);
        setValidationError(error);
        setInputValue($254135e4510bd987$var$sanitizeInputValue(inputValue));
        if (Boolean(inputValue)) {
            experienceTracker.start({
                name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE)
            });
            if (!validationError) debouncedSearchQuery({
                variables: {
                    searchText: inputValue,
                    contentId: contentId
                }
            });
        } else fetchRecommendedLabels();
    };
    const filterOption = ({ value: value })=>{
        return !searchLabelQueryError && (0, $hJzqL.createFilter)({}) && !$254135e4510bd987$export$bfc1bf0a5d12c626(value) && !$254135e4510bd987$var$getValidationError(value);
    };
    const fireLabelChangeEvent = (0, $gwFzn.useCallback)(({ action: action, labels: labels })=>{
        labels.map(({ id: labelId, name: labelName, prefix: labelPrefix, strategy: strategy, subStrategy: subStrategy })=>{
            const recommendedIndex = recommendedLabels?.findIndex(({ id: id })=>id === labelId);
            let recommendedRanking;
            if (recommendedIndex >= 0) {
                recommendedRanking = recommendedIndex;
                if (strategy?.startsWith('searched')) {
                    strategy = 'recommended_searched';
                    subStrategy = recommendedLabels[recommendedIndex].strategy;
                }
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: action,
                    actionSubject: 'label',
                    source: source,
                    objectType: type,
                    objectId: contentId,
                    containerType: 'space',
                    containerId: spaceId,
                    attributes: {
                        contentId: contentId,
                        labelId: labelId,
                        strategy: strategy,
                        subStrategy: subStrategy,
                        isNewLabel: strategy === 'newly_created',
                        privacySafeLabelPrefix: $254135e4510bd987$export$72ac890f53ba46be(labelPrefix),
                        activationId: activationId,
                        recommendedCount: recommendedLabels?.length,
                        hasRecommendations: !!recommendedLabels?.length,
                        recommendedRanking: recommendedRanking,
                        ...isLivePage ? {
                            isLivePage: isLivePage
                        } : null
                    },
                    nonPrivacySafeAttributes: {
                        labelName: labelName,
                        labelPrefix: labelPrefix
                    }
                }
            }).fire();
        });
    }, [
        type,
        source,
        contentId,
        spaceId,
        createAnalyticsEvent,
        activationId,
        recommendedLabels,
        isLivePage
    ]);
    const handleSelectLabel = (0, $gwFzn.useCallback)(async (option)=>{
        experienceTracker.start({
            name: (0, $irVI7.LABELS_ADD_LABEL_EXPERIENCE)
        });
        try {
            await addLabel({
                variables: {
                    labels: [
                        {
                            name: option.name,
                            prefix: option.prefix
                        }
                    ],
                    contentId: contentId
                },
                optimisticResponse: {
                    addLabels: {
                        __typename: 'AddLabelsPayload',
                        labels: {
                            __typename: 'PaginatedLabelList',
                            count: (labelData?.content?.nodes?.[0]?.labels?.count || 0) + 1,
                            nodes: [
                                ...labelData?.content?.nodes?.[0]?.labels?.nodes || [],
                                {
                                    __typename: 'Label',
                                    id: option.id,
                                    prefix: option.prefix,
                                    name: option.name,
                                    label: option.name
                                }
                            ]
                        }
                    }
                }
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_ADD_LABEL_EXPERIENCE)
            });
            fireLabelChangeEvent({
                action: 'add',
                labels: [
                    option
                ]
            });
        } catch (error) {
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_ADD_LABEL_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        addLabel,
        labelData,
        fireLabelChangeEvent,
        contentId
    ]);
    const handleCreateLabel = (0, $gwFzn.useCallback)(async (option)=>{
        experienceTracker.start({
            name: (0, $irVI7.LABELS_CREATE_LABEL_EXPERIENCE)
        });
        try {
            const { data: data } = await addLabel({
                variables: {
                    labels: [
                        {
                            name: option.value,
                            prefix: ''
                        }
                    ],
                    contentId: contentId
                },
                optimisticResponse: {
                    addLabels: {
                        __typename: 'AddLabelsPayload',
                        labels: {
                            __typename: 'PaginatedLabelList',
                            count: (labelData?.content?.nodes?.[0]?.labels?.count || 0) + 1,
                            nodes: [
                                ...labelData?.content?.nodes?.[0]?.labels?.nodes || [],
                                {
                                    name: option.value,
                                    prefix: '',
                                    __typename: 'Label',
                                    id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(),
                                    label: option.value
                                }
                            ]
                        }
                    }
                }
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_CREATE_LABEL_EXPERIENCE)
            });
            fireLabelChangeEvent({
                action: 'add',
                // filter out the newly added labels from the already existing - this is necessary in order to get the new label ids to send in the analytics event
                labels: (data?.addLabels?.labels?.nodes || []).map($254135e4510bd987$var$makeTransformLabelToOption('newly_created')).filter(({ value: value })=>option.value === value)
            });
        } catch (error) {
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_CREATE_LABEL_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        addLabel,
        labelData,
        fireLabelChangeEvent,
        contentId
    ]);
    const handleDeleteLabel = (0, $gwFzn.useCallback)(async (removedValue)=>{
        const optimisticResponse = {
            deleteLabel: {
                __typename: 'DeleteLabelPayload',
                contentId: contentId,
                label: removedValue?.name
            }
        };
        if (!removedValue) return;
        experienceTracker.start({
            name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE)
        });
        try {
            await deleteLabel({
                variables: {
                    label: removedValue.name,
                    contentId: contentId
                }
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE)
            });
            fireLabelChangeEvent({
                action: 'deleted',
                labels: [
                    removedValue
                ]
            });
        } catch (error) {
            if ($254135e4510bd987$var$isLabelNotFoundError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                handleDeleteLabelUpdate((0, $hp2SH.getApolloClient)(), {
                    data: optimisticResponse
                });
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'label already deleted'
                });
            } else if ($254135e4510bd987$var$isContentNotFoundError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'Content was deleted'
                });
            } else if ($254135e4510bd987$var$isLabelDeletePermissionsError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'Edit permissions were removed'
                });
            } else if ($254135e4510bd987$var$isLabelMutationLoggedOutError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'User was logged out'
                });
            } else experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        deleteLabel,
        fireLabelChangeEvent,
        contentId,
        handleDeleteLabelUpdate
    ]);
    const handleLabelChange = async (_, { action: action, option: option, removedValue: removedValue })=>{
        if (action === (0, $eDV4X.ActionTypes).SELECT_OPTION) handleSelectLabel(option);
        else if (action === (0, $eDV4X.ActionTypes).CREATE_OPTION) handleCreateLabel(option);
        else if (action === (0, $eDV4X.ActionTypes).REMOVE_VALUE || action === (0, $eDV4X.ActionTypes).POP_VALUE) handleDeleteLabel(removedValue);
    };
    const handleMenuOpen = (0, $gwFzn.useCallback)(()=>{
        fetchRecommendedLabels();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'open',
                actionSubject: 'labelsSelect',
                source: source,
                containerId: spaceId,
                containerType: 'space',
                objectId: contentId,
                objectType: type
            }
        }).fire();
    }, [
        source,
        spaceId,
        contentId,
        type,
        createAnalyticsEvent,
        fetchRecommendedLabels
    ]);
    const isLoading = searchLabelQueryLoading || recommendedLabelsQueryLoading;
    return {
        options: isLoading ? [] : options,
        value: !(labelsQueryLoading || ssrLabelsQueryLoading) ? selectedOptions : [],
        filterOption: filterOption,
        onChange: handleLabelChange,
        onMenuOpen: handleMenuOpen,
        onInputChange: handleInputChange,
        inputValue: inputValue,
        isLoading: isLoading,
        isDisabled: isDisabled,
        labelsQueryLoading: labelsQueryLoading || ssrLabelsQueryLoading,
        labelsQueryError: labelsQueryError || ssrLabelsQueryError,
        labelsMutationError: addError || deleteError,
        labelsSearchQueryError: searchLabelQueryError,
        validationError: validationError,
        fetchRecommendedLabels: fetchRecommendedLabels
    };
};

});
parcelRegister("cWkqs", function(module, exports) {

var $5w6O6 = parcelRequire("5w6O6");

var $9lCvb = parcelRequire("9lCvb");

var $boEVR = parcelRequire("boEVR");

var $2RyUS = parcelRequire("2RyUS");

var $a4SN8 = parcelRequire("a4SN8");

var $5XKHf = parcelRequire("5XKHf");
/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ var $96babef28bcd79a4$var$unionBy = $boEVR(function(arrays) {
    var iteratee = $5XKHf(arrays);
    if ($a4SN8(iteratee)) iteratee = undefined;
    return $2RyUS($5w6O6(arrays, 1, $a4SN8, true), $9lCvb(iteratee, 2));
});
module.exports = $96babef28bcd79a4$var$unionBy;

});

parcelRegister("775f2", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $52dd40b6282cac81$export$91c32f1b22d29b2d);

var $8yIJl = parcelRequire("8yIJl");
// Regular expression to parse error message key and its arguments.
// Here is exmaple of error string which is returned from server side
// Ex: "com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
// `(?:\w|\.)+` : is a non-capturing group - to match with message key value
// `{1}` - exactly 1 time
// `\s*` : match any white space character
const $52dd40b6282cac81$var$re = /\[messageKey=((?:\w|\.)+){1},\s*args=\[((?:.)+)?\]\]\]/;
function $52dd40b6282cac81$export$91c32f1b22d29b2d(errorMsgObject) {
    let message = '';
    let messageKey = '';
    const args = [];
    if (typeof errorMsgObject === 'object' && errorMsgObject.message) message = errorMsgObject.message;
    // try to get error key and its arguments from error message string
    if (typeof message === 'string' && message.indexOf('messageKey') >= 0) {
        if ($52dd40b6282cac81$var$re.test(message)) {
            const results = $52dd40b6282cac81$var$re.exec(message);
            // first element of array which is returned from `re.exec` is ful string of charecter matched.
            // Ex: if message="com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // results[0] = "[ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // Full detail: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec
            messageKey = results[1];
            // Basing on all error messages patterns, there are maximum of 2 arguments for message.
            const argArray = results[2] ? results[2].split(',') : [];
            if (argArray) {
                args[0] = (0, (/*@__PURE__*/$parcel$interopDefault($8yIJl)))(argArray);
                args[1] = argArray.slice(1).join(', ');
            }
        }
    }
    return {
        message: message,
        messageKey: messageKey,
        args: args
    };
}

});

parcelRegister("eDV4X", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_CONTENT_STATUSES", () => $e24dc53dc88ae3e8$export$3211963609921415);
$parcel$export(module.exports, "ActionTypes", () => $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "INVALID_CHARACTERS", () => $e24dc53dc88ae3e8$export$cac90560d1a4fb86);
$parcel$export(module.exports, "ContentTypes", () => $e24dc53dc88ae3e8$export$b9e669a853ca2f38);
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});

});

parcelRegister("7vJu5", function(module, exports) {

$parcel$export(module.exports, "LabelsQuery", () => $134b5ce25186f5e2$export$8f13056fc1e2a814);

var $d2LG0 = parcelRequire("d2LG0");
const $134b5ce25186f5e2$export$8f13056fc1e2a814 = (0, $d2LG0.default)`query LabelsQuery($contentId:ID!$refetchQuery:Boolean!$status:[String]){content(id:$contentId status:$status){nodes{id type operations@skip(if:$refetchQuery){operation targetType}space{id}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count nodes{id label name prefix}}}}}`;

});


parcelRegister("82T6H", function(module, exports) {

$parcel$export(module.exports, "CustomControl", () => $4efaaf9459684b0b$export$b0c082086b5fac02);
$parcel$export(module.exports, "LabelsSelectComponent", () => $4efaaf9459684b0b$export$adeb07a62d3b4b29);
/* LabelsSelectComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3hOY6 = parcelRequire("3hOY6");
var $eKXGE = parcelRequire("eKXGE");

var $bS1VQ = parcelRequire("bS1VQ");

var $inPa6 = parcelRequire("inPa6");

var $bUlM5 = parcelRequire("bUlM5");

var $3gadb = parcelRequire("3gadb");

var $g5gZt = parcelRequire("g5gZt");

var $jmjWc = parcelRequire("jmjWc");

var $1eaCJ = parcelRequire("1eaCJ");

var $b8XTE = parcelRequire("b8XTE");

var $b5LuY = parcelRequire("b5LuY");

var $h0Kkh = parcelRequire("h0Kkh");

var $8wSYm = parcelRequire("8wSYm");
const { ValueContainer: $4efaaf9459684b0b$var$ValueContainer, Input: $4efaaf9459684b0b$var$Input, Control: $4efaaf9459684b0b$var$Control, MultiValueContainer: $4efaaf9459684b0b$var$MultiValueContainer, MultiValueLabel: $4efaaf9459684b0b$var$MultiValueLabel, Option: $4efaaf9459684b0b$var$Option } = (0, $3hOY6.components);

const $4efaaf9459684b0b$var$LabelsQueryErrorDisplayLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HUfwx",
    name: "LabelsQueryErrorDisplayLoader",
    loader: async ()=>(await (parcelRequire("9qiwd"))).LabelsQueryErrorDisplay
});

const $4efaaf9459684b0b$var$LabelsMutationErrorDisplayLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6xtul",
    name: "LabelsMutationErrorDisplayLoader",
    loader: async ()=>(await (parcelRequire("9qiwd"))).LabelsMutationErrorDisplay
});

const $4efaaf9459684b0b$var$LabelsValidationErrorLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7jZKQ",
    name: "LabelsValidationErrorLoader",
    loader: async ()=>(await (parcelRequire("9qiwd"))).LabelsValidationError
});
const $4efaaf9459684b0b$var$i18n = (0, $2nPZH.defineMessages)({
    inputPlaceholder: {
        id: "labels.labels-select.input-placeholder",
        defaultMessage: "Search or create a label"
    },
    createNewLabel: {
        id: "labels.labels-select.create-new-label",
        defaultMessage: "Create new label"
    },
    addLabelPlaceholder: {
        id: "labels.view-page-labels.placeholder",
        defaultMessage: "Add label"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4efaaf9459684b0b$var$LabelSelectOption = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _1yt4otz2 _2rko1l7b _1e0c1o8l _bfhk1vck _1d261gii",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4efaaf9459684b0b$var$CreateLabelContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4efaaf9459684b0b$var$CreateLabelText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});
const $4efaaf9459684b0b$var$multiValueStyles = {
    root: "_18s81b66 _2rko1l7b _1reo15vq _18m915vq _bfhkm7j4 _lcxv1wug _2lx21sbv _1tgk18uv _6fpb18uv _f6dyglyw _1gv6glyw _1wx1nqa1 _1nc7nqa1 _1pt9ip91 _1ect1rtt _1sjp1fxt _10j7ip91 _irr3ip91"
};
const $4efaaf9459684b0b$var$inputStyles = {
    root: "_p12fze3t _1heu1kw7 _5ce61gjq _5hv91h90"
};
const $4efaaf9459684b0b$var$defaultStyles = {
    valueContainer: (provided)=>({
            ...provided,
            paddingLeft: "var(--ds-space-050, 4px)",
            paddingRight: "var(--ds-space-050, 4px)",
            paddingTop: "var(--ds-space-050, 4px)",
            paddingBottom: "var(--ds-space-050, 4px)",
            display: 'flex'
        }),
    group: (provided)=>({
            ...provided,
            paddingTop: '0'
        }),
    groupHeading: (provided)=>({
            ...provided,
            font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            marginBottom: "var(--ds-space-100, 8px)"
        }),
    multiValueLabel: (provided)=>({
            ...provided,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingLeft: "var(--ds-space-050, 4px)",
            paddingRight: "var(--ds-space-025, 2px)",
            maxWidth: '400px',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
    multiValue: (provided)=>({
            ...provided,
            margin: "var(--ds-space-050, 4px)",
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            '&:hover, &:focus-within': {
                backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)"
            },
            '&:hover .labels__multi-value__label span': {
                backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)"
            },
            borderRadius: '3px',
            '&:hover a, &:focus-within a': {
                textDecoration: 'none'
            },
            pointerEvents: 'auto',
            overflow: 'hidden',
            flexDirection: 'row-reverse',
            'div:hover + div': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
            },
            'a > .labels__multi-value__label': {
                color: "var(--ds-text, #172B4D)"
            }
        }),
    option: (provided)=>({
            ...provided,
            width: 'max-content',
            minWidth: '100%'
        }),
    input: (provided)=>({
            ...provided,
            input: {
                fontFamily: 'inherit',
                '::placeholder': {
                    color: "var(--ds-text-subtle, #44546F)"
                },
                width: 'auto !important' // needed after upgrading react-select to a version that no longer uses react-input-autosize
            },
            maxWidth: 0
        })
};
const $4efaaf9459684b0b$var$getDisabledStyles = (isDisabled)=>{
    return isDisabled ? {
        control: (provided)=>({
                ...provided,
                '&:hover, &:focus, &:active, &:focus-within': {
                    borderColor: "var(--ds-border-inverse, #FFFFFF)"
                },
                '&:focus-within, :hover': {
                    borderColor: "var(--ds-border-inverse, #FFFFFF)"
                },
                cursor: 'default !important',
                borderWidth: '0px'
            }),
        multiValueLabel: (provided)=>({
                ...provided,
                paddingRight: "var(--ds-space-050, 4px)"
            })
    } : {};
};
const $4efaaf9459684b0b$export$b0c082086b5fac02 = ({ children: children, ...props })=>{
    const { isFocused: isFocused } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$Control, props, (0, $gwFzn.Children).map(children, (child)=>{
        if (child?.type === $4efaaf9459684b0b$var$CustomValueContainer) return /*#__PURE__*/ (0, $gwFzn.cloneElement)(child, {
            isFocused: isFocused
        });
        return child;
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4efaaf9459684b0b$var$CustomPlaceholder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $4efaaf9459684b0b$var$AddLabelPlaceholder = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4efaaf9459684b0b$var$i18n.addLabelPlaceholder));
};
const $4efaaf9459684b0b$var$CustomValueContainer = ({ children: children, isFocused: isFocused, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$ValueContainer, props, (0, $gwFzn.Children).map(children, (child)=>{
        if (child?.type === $4efaaf9459684b0b$var$CustomInput) return /*#__PURE__*/ (0, $gwFzn.cloneElement)(child, {
            isFocused: isFocused
        });
        return child;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$CustomPlaceholder, null, !isFocused ? props.selectProps.placeholder : null));
};
const $4efaaf9459684b0b$var$CustomInput = ({ isFocused: // @ts-expect-error isFocused is not provided by react-select
isFocused, ...props })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$Input, {
        ...props,
        xcss: $4efaaf9459684b0b$var$inputStyles.root,
        placeholder: isFocused ? intl.formatMessage($4efaaf9459684b0b$var$i18n.inputPlaceholder) : undefined
    });
}; // @atlaskit/select does not reexport the types we need: https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/components/MultiValue.tsx#L92
const $4efaaf9459684b0b$var$CustomMultiValueContainer = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$MultiValueContainer, {
        ...props,
        xcss: $4efaaf9459684b0b$var$multiValueStyles.root
    }, (0, $gwFzn.Children).toArray(children).reverse());
};
const $4efaaf9459684b0b$var$CustomMultiValueLabel = ({ spaceKey: spaceKey, source: source, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'label',
                source: source,
                attributes: {
                    privacySafePrefix: (0, $b5LuY.getPrivacySafePrefix)(props.data.prefix)
                }
            }
        }).fire();
    }, [
        source,
        props.data.prefix,
        createAnalyticsEvent
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        onMouseDown: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: String(props.data.value).length >= 50 ? props.data.value : ''
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
            href: `/wiki/label/${spaceKey}/${props.data.value}`,
            ...tooltipProps,
            onClick: handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$MultiValueLabel, props)))));
};
const $4efaaf9459684b0b$var$CustomOption = ({ children: children, ...props })=>{
    const { data: { __isNew__: __isNew__ }, value: value } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$Option, props, __isNew__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$CreateLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$CreateLabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4efaaf9459684b0b$var$i18n.createNewLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$LabelSelectOption, null, value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$LabelSelectOption, null, value));
};
const $4efaaf9459684b0b$export$adeb07a62d3b4b29 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ isDisabled: isDisabled, labelsQueryLoading: labelsQueryLoading, labelsQueryError: labelsQueryError, labelsMutationError: labelsMutationError, validationError: validationError, fetchRecommendedLabels: fetchRecommendedLabels, experienceName: experienceName, isInDialog: isInDialog, spaceKey: spaceKey, source: source, styles: styles, customProps: customProps, controlledProps: controlledProps, components: components, getNoOptionsMessage: getNoOptionsMessage }, ref)=>{
    const intl = (0, $dBxQj.default)();
    if (labelsQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$LabelsQueryErrorDisplayLoader, {
        experienceName: experienceName,
        error: labelsQueryError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isInDialog || !labelsQueryLoading ? // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        onMouseEnter: fetchRecommendedLabels
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bS1VQ.default), {
        components: {
            DropdownIndicator: null,
            Placeholder: ()=>null,
            Control: $4efaaf9459684b0b$export$b0c082086b5fac02,
            ...!isDisabled && {
                ValueContainer: $4efaaf9459684b0b$var$CustomValueContainer
            },
            Input: $4efaaf9459684b0b$var$CustomInput,
            MultiValueContainer: $4efaaf9459684b0b$var$CustomMultiValueContainer,
            MultiValueLabel: (props)=>//@ts-ignore react-select types
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$CustomMultiValueLabel, {
                    spaceKey: spaceKey,
                    source: source,
                    ...props
                }),
            ...isDisabled && {
                MultiValueRemove: ()=>null
            },
            Option: $4efaaf9459684b0b$var$CustomOption,
            ...components
        },
        ref: ref,
        noOptionsMessage: ({ inputValue: inputValue })=>getNoOptionsMessage(inputValue),
        styles: (0, $eKXGE.mergeStyles)($4efaaf9459684b0b$var$defaultStyles, (0, $eKXGE.mergeStyles)($4efaaf9459684b0b$var$getDisabledStyles(Boolean(isDisabled)), styles || {})),
        isClearable: false,
        openMenuOnClick: true,
        "aria-label": intl.formatMessage($4efaaf9459684b0b$var$i18n.addLabelPlaceholder),
        isSearchable: !isDisabled,
        closeMenuOnSelect: false,
        defaultOptions: true,
        isMulti: true,
        classNamePrefix: "labels",
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$AddLabelPlaceholder, null),
        validationState: validationError ? 'error' : 'default',
        ...controlledProps,
        ...customProps
    }), labelsMutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$LabelsMutationErrorDisplayLoader, {
        error: labelsMutationError
    }), validationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4efaaf9459684b0b$var$LabelsValidationErrorLoader, {
        error: validationError,
        input: controlledProps.inputValue
    }), !labelsQueryLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: experienceName
    }), source == 'viewPage' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $8wSYm.VIEW_PAGE_LABELS_METRIC)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h0Kkh.LabelsSelectPlaceholder), null));
});

});
parcelRegister("b8XTE", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadEnd", () => $eb0c119b7155e6d7$export$a267cdf45880b07b);

var $gwFzn = parcelRequire("gwFzn");

var $3kTfj = parcelRequire("3kTfj");

var $1NBp8 = parcelRequire("1NBp8");

var $78QFu = parcelRequire("78QFu");


var $dIouf = parcelRequire("dIouf");

var $N1nBh = parcelRequire("N1nBh");

var $3YpC9 = parcelRequire("3YpC9");

var $6VdZc = parcelRequire("6VdZc");

var $lXYVJ = parcelRequire("lXYVJ");
const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    const handlePageSegmentLoadMetricStop = (0, $gwFzn.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterComplete) finalCustomData = augmentCustomDataAfterComplete(customData);
            else finalCustomData = customData;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTime
            });
        }
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData` or `stopTime`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
});
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);

});
parcelRegister("N1nBh", function(module, exports) {

$parcel$export(module.exports, "ActionTiming", () => $4fef2d066feab689$export$6a673e74e98cdf55);
$parcel$export(module.exports, "usePerformanceAction", () => $4fef2d066feab689$export$454639fd58f598bd);

var $gwFzn = parcelRequire("gwFzn");
var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $gwFzn.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};

});

parcelRegister("lXYVJ", function(module, exports) {

$parcel$export(module.exports, "setViewTransitionSource", () => $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5);
$parcel$export(module.exports, "getViewTransitionSource", () => $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0);
$parcel$export(module.exports, "resetViewTransitionSource", () => $3ef2d7a9f25e0216$export$6dffe64fdadf1e02);

var $1C3B1 = parcelRequire("1C3B1");
let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};

});
parcelRegister("1C3B1", function(module, exports) {

$parcel$export(module.exports, "PAGE_TREE_ITEM_CLICK", () => $f3fed16e32582dfc$export$f32efcfda8942c38);
$parcel$export(module.exports, "RECENT_DROPDOWN_ITEM_CLICK", () => $f3fed16e32582dfc$export$e20b00d7fdb37fd5);
$parcel$export(module.exports, "EDITOR_UPDATE_BUTTON_CLICK", () => $f3fed16e32582dfc$export$861af28956854f4d);
$parcel$export(module.exports, "EDITOR_UPDATE_SHORTCUT_KEY_PRESS", () => $f3fed16e32582dfc$export$3a68be40f6a0cf8d);
$parcel$export(module.exports, "EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK", () => $f3fed16e32582dfc$export$14ad6d5644be3ef2);
$parcel$export(module.exports, "EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS", () => $f3fed16e32582dfc$export$26bf8dd7a8a304a2);
$parcel$export(module.exports, "EDITOR_CLOSE_BUTTON_CLICK", () => $f3fed16e32582dfc$export$35f8dbb53e30cb83);
$parcel$export(module.exports, "RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK", () => $f3fed16e32582dfc$export$56128408995abf4c);
$parcel$export(module.exports, "DISCOVER_ITEM_ON_HOME_PAGE_CLICK", () => $f3fed16e32582dfc$export$c6abfcd7964138ae);
$parcel$export(module.exports, "UNKNOWN", () => $f3fed16e32582dfc$export$78244dbb77cfa6b6);
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';

});



parcelRegister("h0Kkh", function(module, exports) {

$parcel$export(module.exports, "LabelsSelectPlaceholder", () => $65506fb9cb0b5423$export$78128841bacb1fe0);
$parcel$export(module.exports, "ViewPageLabelsLoader", () => $65506fb9cb0b5423$export$34eb2891dd16ab98);
/* ViewPageLabelsLoader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $jmjWc = parcelRequire("jmjWc");

var $7d2Nc = parcelRequire("7d2Nc");

var $8wSYm = parcelRequire("8wSYm");
const $65506fb9cb0b5423$export$78128841bacb1fe0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});

const $65506fb9cb0b5423$var$ViewPageLabelsLoaderBase = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-JIDW",
    name: "ViewPageLabelsLoaderBase",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($65506fb9cb0b5423$export$78128841bacb1fe0, null),
    loader: async ()=>(await (parcelRequire("4CV66"))).ViewPageLabels
});
const $65506fb9cb0b5423$export$34eb2891dd16ab98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $8wSYm.VIEW_PAGE_LABELS_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($65506fb9cb0b5423$var$ViewPageLabelsLoaderBase, props));

});
parcelRegister("7d2Nc", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadStart", () => $c2bdb1677e0a2d6c$export$f11db193fdaffcc9);

var $gwFzn = parcelRequire("gwFzn");

var $3kTfj = parcelRequire("3kTfj");


var $dIouf = parcelRequire("dIouf");

var $N1nBh = parcelRequire("N1nBh");

var $3YpC9 = parcelRequire("3YpC9");
const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $gwFzn.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);

});

parcelRegister("8wSYm", function(module, exports) {

$parcel$export(module.exports, "VIEW_PAGE_LABELS_METRIC", () => $75d6bda68d542847$export$3a36b2d62e2d34a2);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
const $75d6bda68d542847$export$3a36b2d62e2d34a2 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY)
});

});
parcelRegister("jX1qB", function(module, exports) {

$parcel$export(module.exports, "APP_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$9e40500efe28ac9e);
$parcel$export(module.exports, "BLOG_TREE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$38b273cdbbf56c26);
$parcel$export(module.exports, "BYLINE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1ac23cd5807df863);
$parcel$export(module.exports, "READ_TIME_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$5bbb36bee09a5671);
$parcel$export(module.exports, "CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$a79607497a4a710c);
$parcel$export(module.exports, "CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$c56a99673f1bb7bb);
$parcel$export(module.exports, "CONTENT_RENDERER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$140a493a9e781fe2);
$parcel$export(module.exports, "CONTENT_TITLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$db1285ccb0399c01);
$parcel$export(module.exports, "FAVOURITE_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$eb5bb54418693284);
$parcel$export(module.exports, "FOCUSED_INLINE_COMMENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3fde425dbc74423b);
$parcel$export(module.exports, "INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$6a58cce6529da40e);
$parcel$export(module.exports, "FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$8910bc840e3ee4ce);
$parcel$export(module.exports, "RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$bf572571ca036b67);
$parcel$export(module.exports, "EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$644778267d4a4a82);
$parcel$export(module.exports, "MEDIA_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7416ef7ed24ec47f);
$parcel$export(module.exports, "PAGE_COMMENTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e4ff10a0a39a7217);
$parcel$export(module.exports, "PAGE_REACTIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$6648c9be174e6923);
$parcel$export(module.exports, "FEED_REACTIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2d3d6144128aaee3);
$parcel$export(module.exports, "PAGE_TREE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499);
$parcel$export(module.exports, "RESTRICTIONS_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$d1dfca9e0eb45581);
$parcel$export(module.exports, "GLOBAL_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$312db7b759bad970);
$parcel$export(module.exports, "SPACE_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$cf2a6bf49e73b304);
$parcel$export(module.exports, "SPACE_APPS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$84f6b5717c3fb962);
$parcel$export(module.exports, "WATCH_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1a423f2548c46be3);
$parcel$export(module.exports, "HOME_OVERVIEW_RECENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b6426c6941656619);
$parcel$export(module.exports, "HOME_OVERVIEW_FEED_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$14f30a91623dfcf3);
$parcel$export(module.exports, "HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$c6926beb57b60636);
$parcel$export(module.exports, "HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$687913e127f52cc3);
$parcel$export(module.exports, "HOME_RECENTS_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0);
$parcel$export(module.exports, "HOME_STARRED_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$76243e8aa4afaa0b);
$parcel$export(module.exports, "HOME_DRAFTS_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e1df6f3f29083f48);
$parcel$export(module.exports, "END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7b32848c9413526a);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$58fbb0ba50341103);
$parcel$export(module.exports, "NCS_CONNECTED_FMP_KEY", () => $fa0ea3428ec5aa62$export$4f481f063369df3c);
$parcel$export(module.exports, "ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$db1b9793e009e605);
$parcel$export(module.exports, "ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$90bda069d4bf981b);
$parcel$export(module.exports, "ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$f11e1d4269141c0e);
$parcel$export(module.exports, "DATABASE_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$f0298cbab4a44998);
$parcel$export(module.exports, "SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5);
$parcel$export(module.exports, "WHITEBOARD_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$cf2f52fec740bdea);
$parcel$export(module.exports, "OBJECT_HEADER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$52050233077a1838);
$parcel$export(module.exports, "CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e1ab333f0b70b317);
$parcel$export(module.exports, "WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4);
$parcel$export(module.exports, "DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b95bd4bfc46932fc);
$parcel$export(module.exports, "SHARE_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$bf838b84ba2f7b95);
$parcel$export(module.exports, "VIEW_PAGE_LABELS_METRIC_KEY", () => $fa0ea3428ec5aa62$export$79910402df6be117);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$d86af34f7dc194b4);
$parcel$export(module.exports, "CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb);
$parcel$export(module.exports, "SPACE_PERMISSIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1939caa7fae28ef5);
$parcel$export(module.exports, "VIEW_PAGE_CONTAINER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3f06ee123a5ad183);
$parcel$export(module.exports, "EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$37da6122cd60d332);
$parcel$export(module.exports, "EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3437c1f145cfce19);
$parcel$export(module.exports, "EDITOR_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7903037283afbce0);
$parcel$export(module.exports, "RECAP_MODAL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$fdd1a35fb559480a);
$parcel$export(module.exports, "OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$31d10d7597db11d3);
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';

});


parcelRegister("4CV66", function(module, exports) {

let $35e700616619ea47$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $35e700616619ea47$var$load("3kHns"),
    $35e700616619ea47$var$load("3JzPO"),
    $35e700616619ea47$var$load("4gtMV"),
    $35e700616619ea47$var$load("1kb22"),
    $35e700616619ea47$var$load("fwFM0")
]).then(()=>parcelRequire('eKYmP'));

});


parcelRegister("9qiwd", function(module, exports) {

let $6dc4e82b9ae0fbcc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6dc4e82b9ae0fbcc$var$load("a7qwF").then(()=>parcelRequire('e8Hs8'));

});


parcelRegister("5ZTcm", function(module, exports) {

let $45dd7781515b5e63$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $45dd7781515b5e63$var$load("5IJHO").then(()=>parcelRequire('hWhwi'));

});



//# sourceMappingURL=LabelsSelect.e87410ae.js.map
